module.exports = __webpack_public_path__ + "img/edge_hebergements_hebergements_groupe.102ee03a.svg";